import Konva from "konva";
import CustomText from "../CustomText";

export function renderWriteBox(block, crystalizedData, options) {
  const { x = 0, y = 0, width = 300, height = 200, imageCallback, fontScale = 1 } = options;
  const s = fontScale;
  const group = new Konva.Group({ x, y, width, height });

  const pad = Math.round(8 * s);
  let cy = pad;

  if (block.label) {
    const label = new CustomText({
      x: pad, y: cy, width: width - pad * 2,
      text: block.label.toUpperCase(),
      fontSize: Math.round(9 * s), fontStyle: "bold",
      fill: "#999",
      lineHeight: 1.3, refreshCallback: imageCallback
    });
    group.add(label);
    cy += label.height() + Math.round(5 * s);
  }

  const boxH = Math.max(Math.round(20 * s), height - cy - pad);
  const dash = Math.round(5 * s);
  group.add(new Konva.Rect({
    x: pad, y: cy,
    width: width - pad * 2, height: boxH,
    fill: "#FAFAFA",
    stroke: "#CCCCCC", strokeWidth: 1,
    cornerRadius: Math.round(4 * s),
    dash: [dash, Math.round(dash * 0.75)]
  }));

  group.height(height);
  return group;
}
